import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Download icon.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const DownloadIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path
      d="M3.5 12.7998V12.667C3.5 12.3909 3.72386 12.167 4 12.167C4.27614 12.167 4.5 12.3909 4.5 12.667V12.7998C4.5 13.3681 4.50019 13.7648 4.52539 14.0732C4.55009 14.3753 4.59613 14.5491 4.66309 14.6807C4.8069 14.9629 5.03709 15.1931 5.31934 15.3369C5.45091 15.4039 5.62471 15.4499 5.92676 15.4746C6.23518 15.4998 6.63189 15.5 7.2002 15.5H12.7998C13.3681 15.5 13.7648 15.4998 14.0732 15.4746C14.3753 15.4499 14.5491 15.4039 14.6807 15.3369C14.9629 15.1931 15.1931 14.9629 15.3369 14.6807C15.4039 14.5491 15.4499 14.3753 15.4746 14.0732C15.4998 13.7648 15.5 13.3681 15.5 12.7998V12.667C15.5 12.3909 15.7239 12.167 16 12.167C16.2761 12.167 16.5 12.3909 16.5 12.667V12.7998C16.5 13.3516 16.5 13.7957 16.4707 14.1543C16.4409 14.5186 16.3784 14.8387 16.2275 15.1348C15.9879 15.6052 15.6052 15.9879 15.1348 16.2275C14.8387 16.3784 14.5186 16.4409 14.1543 16.4707C13.7957 16.5 13.3516 16.5 12.7998 16.5H7.2002C6.64839 16.5 6.20429 16.5 5.8457 16.4707C5.48136 16.4409 5.16133 16.3784 4.86523 16.2275C4.39483 15.9879 4.01214 15.6052 3.77246 15.1348C3.62163 14.8387 3.55907 14.5186 3.5293 14.1543C3.5 13.7957 3.5 13.3516 3.5 12.7998ZM9.5 4C9.5 3.72386 9.72386 3.5 10 3.5C10.2761 3.5 10.5 3.72386 10.5 4V11.46L12.3135 9.64648C12.5088 9.45139 12.8253 9.45128 13.0205 9.64648C13.2156 9.84171 13.2156 10.1583 13.0205 10.3535L10.8252 12.5488C10.3696 13.0044 9.63042 13.0044 9.1748 12.5488L6.97949 10.3535C6.78445 10.1583 6.78445 9.84171 6.97949 9.64648C7.1747 9.45128 7.49125 9.45139 7.68652 9.64648L9.5 11.46V4Z"
      fill="currentColor"
    />
  </svg>
);

export default DownloadIcon;
